import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=90e2ff76&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=90e2ff76&scoped=true&lang=scss&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e2ff76",
  null
  
)

export default component.exports